<template>
	<form data-vv-scope="tenantRegistration">
		<div class="number-prefix">
			<!--<label for="tenant-login-form-account-number">Account Number</label>-->
			<input
				class="col-12 form-control login-signup-input"
				type="text"
				placeholder="Account Number"
				v-validate="accountValidation"
				data-ismobileonly="false"
				name="Account Number"
				v-model="accountNumber"
				:class="{ 'is-invalid': errors.has('tenantRegistration.Account Number') && showLoginError}"
				id="tenant-login-form-account-number"
				data-test="loginFormAccNoInput"
			>
			<div
				class="invalid-feedback"
				v-if="(errors.has('tenantRegistration.Account Number') && showLoginError)"
				id="login-form-acc-no-error"
				data-test="loginFormEmailInputError"
			>
				{{ errors.first('tenantRegistration.Account Number') }}
			</div>
			<!-- Password Input field and error-->
			<!--<div class="col-12 p-0" v-if="!bankLoginOtpSend">-->
			<!--<input-->
			<!--v-validate="'required|min:6'"-->
			<!--:class="(showLoginError &&-->
			<!--errors.has('tenantRegistration.password'))?'is-invalid':''"-->
			<!--class="form-control login-signup-input mt-2"-->
			<!--data-ismobileonly="false"-->
			<!--name="password"-->
			<!--type="password"-->
			<!--placeholder="Create New Password"-->
			<!--id="tenantRegistration-password"-->
			<!--v-model="password"-->
			<!--autocomplete="off"-->
			<!--ref="password"-->
			<!--data-test="tenantRegistrationFormPsswrdInput"-->
			<!--&gt;-->
			<!--<div-->
			<!--class="invalid-feedback"-->
			<!--v-if="showLoginError"-->
			<!--v-show="errors.has('tenantRegistration.password')"-->
			<!--id="signup-password-error"-->
			<!--data-test="tenantRegistrationFormPasswrdInputError"-->
			<!--&gt;-->
			<!--{{errors.first('tenantRegistration.password')}}-->
			<!--</div>-->
			<!--</div>-->
			<!--Confirm Password Input field and error-->
			<!--<div class="col-12 p-0" v-if="!bankLoginOtpSend">-->
			<!--<input-->
			<!--v-validate="'required|confirmed:password'"-->
			<!--:class="(showLoginError &&-->
			<!--errors.has('tenantRegistration.confirmpassword'))?'is-invalid':''"-->
			<!--class="form-control login-signup-input mt-2"-->
			<!--name="confirmpassword"-->
			<!--type="password"-->
			<!--placeholder="Confirm Password"-->
			<!--id="signup-confirm-password"-->
			<!--autocomplete="off"-->
			<!--v-model="confirmPassword"-->
			<!--data-ismobileonly="false"-->
			<!--data-test="tenantRegistrationFormConfirmInput"-->
			<!--&gt;-->
			<!--<div-->
			<!--class="invalid-feedback"-->
			<!--v-if="showLoginError"-->
			<!--v-show="errors.has('tenantRegistration.confirmpassword')"-->
			<!--id="signup-confirm-password-error"-->
			<!--data-test="tenantRegistrationFormConfirmInputError"-->
			<!--&gt;-->
			<!--The password confirmation does not match.-->
			<!--</div>-->
			<!--</div>-->
			<!--<input-->
			<!--class="col-12 form-control login-signup-input mt-2 mb-2"-->
			<!--type="password"-->
			<!--placeholder="Otp"-->
			<!--data-ismobileonly="false"-->
			<!--name="otp"-->
			<!--v-model="otp"-->
			<!--id="login-form-password"-->
			<!--:class="{ 'is-invalid': errors.has('tenantRegistration.otp') && showLoginError}"-->
			<!--v-validate="'required|min:6'"-->
			<!--ref="otp"-->
			<!--v-if="bankLoginOtpSend"-->
			<!--data-test="loginFormPsswrdInput"-->
			<!--&gt;-->
			<!--<div-->
			<!--class="invalid-feedback"-->
			<!--v-if="(errors.has('tenantRegistration.otp') && showLoginError)"-->
			<!--id="login-form-password-error"-->
			<!--data-test="loginFormPsswrdInputError"-->
			<!--&gt;-->
			<!--{{ errors.first('tenantRegistration.otp') }}-->
			<!--</div>-->
			<p class="terms"
						data-test="loginFormPara1"
						id="loginFormPara1"
			>
				By continuing, you agree to
				<router-link to="/pages/terms"
																	data-test="loginFormLink1"
																	id="loginFormLink1">
					Terms and Conditions of Use
				</router-link>
				and
				<router-link to="/pages/privacy"
																	data-test="loginFormLink2"
																	id="loginFormLink2">
					Privacy Notice
				</router-link>
				.
			</p>
		</div>
		<button
			class="ripplelink btn col-12 blue-btn continue-btn mt-2"
			@click.prevent="action('tenantRegistration')"
			id="bank-login-form-send-otp-btn"
			data-test="bankLoginFormSendOtpBtn"
			:disabled="otpSendSuccess"
		>
			{{otpSendSuccess?'Registering...': 'Register Now'}}
		</button>
	</form>
</template>

<script>
import { authenticationApi } from '../../../../services/ApiServices/authenticationApi'

export default {
	name: 'TenantLoginForm',
	data () {
		return {
			bankLoginOtpSend: false,
			showLoginError: false,
			otpSendSuccess: false,
			inputData: 'account',
			accountNumber: '',
			cardNumberData: '',
			otp: '',
			password: '',
			confirmPassword: ''
		}
	},
	computed: {
		accountValidation () {
			if (this.inputData === 'account') {
				return 'required'
			}
			return ''
		},
		cardValidation () {
			if (this.inputData === 'card') {
				return 'required'
			}
			return ''
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.otpSendSuccess = true
					this.showLoginError = false
					this.tenantRegistration(this.accountNumber)
				} else {
					this.otpSendSuccess = false
					this.showLoginError = true
				}
			})
		},
		confirmModal () {
			this.$dialog
				.alert('We have received your inquiry. We will process your request as soon as possible and get back to you shortly.')
				.then((dialog) => {
					this.$router.push('/')
				})
		},
		tenantRegistration (accNo, cardNo, passwordData) {
			authenticationApi.tenantRegistration(accNo, cardNo, passwordData)
				.then(() => {
					this.confirmModal()
					// this.otp = res.data.message
				})
				.catch(() => {
					this.confirmModal()
					// this.otpSendSuccess = false
					// this.bankLoginOtpSend = false
				})
		},
		bankOtpVerify () {
			authenticationApi.bankAccountLoginOtpVerify(this.otp)
				.then(() => {
					this.$router.push('/')
				})
		}
	},
	watch: {
		inputData () {
			this.showLoginError = false
			this.otp = ''
			this.bankLoginOtpSend = false
			this.otpSendSuccess = false
			this.password = ''
			this.confirmPassword = ''
		}
	}
}
</script>

<style scoped>

</style>
